// extracted by mini-css-extract-plugin
export default {"waitlist":"WaitlistToggle-module--waitlist--c9e6a","switch":"WaitlistToggle-module--switch--cc933"};